var w = (t, s, i) => {
  if (!s.has(t))
    throw TypeError("Cannot " + i);
};
var a = (t, s, i) => (w(t, s, "read from private field"), i ? i.call(t) : s.get(t)), u = (t, s, i) => {
  if (s.has(t))
    throw TypeError("Cannot add the same private member more than once");
  s instanceof WeakSet ? s.add(t) : s.set(t, i);
}, h = (t, s, i, e) => (w(t, s, "write to private field"), e ? e.call(t, i) : s.set(t, i), i);
import { contextNotFound as C, ctxCallOutOfScope as S, timerNotFound as E } from "@milkdown/exception";
const N = () => {
  const t = /* @__PURE__ */ new Map();
  return { getSlice: (i) => {
    const e = typeof i == "string" ? [...t.values()].find((n) => n.name === i) : t.get(i.id);
    if (!e) {
      const n = typeof i == "string" ? i : i.sliceName;
      throw C(n);
    }
    return e;
  }, sliceMap: t };
}, T = (t) => Array.isArray(t) ? [...t] : typeof t == "object" ? { ...t } : t, P = (t, s) => {
  const i = Symbol("Context"), e = (n, f = T(t)) => {
    let o = f;
    const c = {
      name: s,
      id: i,
      set: (r) => {
        o = r;
      },
      get: () => o,
      update: (r) => {
        o = r(o);
      }
    };
    return n.set(i, c), c;
  };
  return e.sliceName = s, e.id = i, e._typeInfo = () => {
    throw S();
  }, e;
};
var l, d;
class k {
  constructor(s, i) {
    u(this, l, void 0);
    u(this, d, void 0);
    this.use = (e) => a(this, l).getSlice(e), this.get = (e) => this.use(e).get(), this.set = (e, n) => this.use(e).set(n), this.update = (e, n) => this.use(e).update(n), this.timing = (e) => a(this, d).get(e), this.wait = (e) => this.timing(e)(), this.done = (e) => this.timing(e).done(), this.waitTimers = async (e) => {
      await Promise.all(this.get(e).map((n) => this.wait(n)));
    }, h(this, l, s), h(this, d, i);
  }
}
l = new WeakMap(), d = new WeakMap();
var m, g;
class x {
  constructor(s, i) {
    u(this, m, void 0);
    u(this, g, void 0);
    this.inject = (e, n) => (e(a(this, m).sliceMap, n), this), this.record = (e) => (e(a(this, g).store), this), h(this, m, s), h(this, g, i);
  }
}
m = new WeakMap(), g = new WeakMap();
const L = () => {
  const t = /* @__PURE__ */ new Map();
  return {
    store: t,
    get: (i) => {
      const e = t.get(i.id);
      if (!e)
        throw E(i.name);
      return e;
    }
  };
}, j = (t, s = 3e3) => {
  const i = Symbol("Timer"), e = (n) => {
    let f = !1, o;
    const c = Symbol(t), r = () => f ? Promise.resolve(void 0) : new Promise((p, y) => {
      o = (v) => {
        v instanceof CustomEvent && v.detail.id === c && (f = !0, p());
      }, setTimeout(() => {
        y(`Timing ${t} timeout.`), removeEventListener(t, o);
      }, s), addEventListener(t, o);
    });
    return r.done = () => {
      const p = new CustomEvent(t, { detail: { id: c } });
      dispatchEvent(p), removeEventListener(t, o);
    }, n.set(i, r), r;
  };
  return e.id = i, e;
};
export {
  k as Ctx,
  x as Pre,
  L as createClock,
  N as createContainer,
  P as createSlice,
  j as createTimer
};
//# sourceMappingURL=index.es.js.map
